import dojoTheme from './dojo-theme';
import certwise from './certwise';
export default {
    theme: Object.assign({}, dojoTheme.theme, certwise.theme),
    variants: {
        default: dojoTheme.variants.default,
        pmp: certwise.variants.pmp,
        epm: certwise.variants.epm
    }
};
